import { giveMeThatValue } from "@chatfood/core-utils";

const getErrorObject = (error: unknown): Record<string, string> | undefined => {
  if (!isValidObject(error)) return undefined;

  return typeof error === "object" && error !== null && "data" in error
    ? giveMeThatValue(["data", "data"], error)
    : undefined;
};

const isValidObject = (error: unknown): boolean => {
  return Boolean(
    error && typeof error === "object" && Object.keys(error).length > 0,
  );
};

export function useBffErrors() {
  const errorsToList = (error: unknown): string[] | undefined => {
    const incomingErrors = getErrorObject(error);
    if (!incomingErrors) return;

    const keys = Object.keys(incomingErrors);
    return keys.map((key) => `${incomingErrors[key]}`);
  };

  const errorsToString = (
    error: unknown,
    linebreak: string = "",
  ): string | undefined => {
    const incomingErrors = errorsToList(error);
    if (!incomingErrors) return;

    if (!Array.isArray(incomingErrors)) {
      throw new TypeError("errorsToList should return an array");
    }

    return incomingErrors.join(linebreak);
  };

  const isValidBffError = (error: unknown): boolean => {
    const incomingErrors = getErrorObject(error);
    return isValidObject(incomingErrors);
  };

  return {
    errorsToString,
    errorsToList,
    isValidBffError,
  };
}
